var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg12(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "284.99mm",
    height: "90.714mm",
    viewBox: "0 0 284.99 90.714",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8499"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1.4305e-5 0h960v540h-960z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8531"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.5259e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8541"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-1.5259e-5 540h960v-540l-960 6.1035e-5",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8551"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8561"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m-6.1035e-5 540h960v-540h-960",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8575"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m326.25 228h72v72h-72z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8585"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8613"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m178.91 275.74 40.17-12.28-11.99-39.2-40.17 12.28z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8623"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8633"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m373.5 128.25h252.75v252.75h-252.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8643"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8665"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m570.75 127.5h251.25v252.75h-251.25z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8675"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8705"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m695.25 125.25h264.75v265.5h-264.75z",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clipPath8715"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h72.75v72.75h-72.75z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-616.1 -419.46)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.35278 0 0 -.35278 562.43 556.29)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m152.14 130.71h807.86v257.14h-807.86z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8499)"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1,0,0,-1,7.2,494.7)",
    fill: "#000000",
    fontFamily: "TimesNewRomanPSMT",
    fontSize: "39.8px"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: "0 28.5366 46.526199 64.5158 84.7342 94.525002 105.7486 125.967 145.5088 163.4984 183.7168 194.9404 215.1588 228.651 247.4366 257.90399 271.39621 289.3858 307.3754 327.59381 341.086 361.30441 377.02539 385.3038 398.79599 425.064",
    y: 0
  }, "Keep inventory records (C)"))), /*#__PURE__*/React.createElement("path", {
    d: "m219.38 244.5c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m219.38 244.5c0 27.96 22.66 50.62 50.62 50.62s50.63-22.66 50.63-50.62-22.67-50.63-50.63-50.63-50.62 22.67-50.62 50.63z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.13 172.12h17.25v44.25h-17.25z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m247.13 172.12h17.25v44.25h-17.25z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.63 172.12h16.5v44.25h-16.5z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m275.63 172.12h16.5v44.25h-16.5z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.38 255c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.38 255c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.13 289.12 25.5 49.5 25.5-49.5z",
    fill: "#4472c4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m241.13 289.12 25.5 49.5 25.5-49.5z",
    fill: "none",
    stroke: "#2f528f",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8531)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m219.49 232.72-13.49 4.26c-7.44 2.36-12.32 7.94-10.89 12.47 1.43 4.52 8.63 6.28 16.08 3.93l13.48-4.27z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m219.49 232.72-13.49 4.26c-7.44 2.36-12.32 7.94-10.89 12.47 1.43 4.52 8.63 6.28 16.08 3.93l13.48-4.27z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8551)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m304.58 250.62 16.43 10.59c9.07 5.85 19.01 6.59 22.2 1.64 3.19-4.94-1.59-13.69-10.66-19.54l-16.43-10.59z",
    fill: "#000000",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8561)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m304.58 250.62 16.43 10.59c9.07 5.85 19.01 6.59 22.2 1.64 3.19-4.94-1.59-13.69-10.66-19.54l-16.43-10.59z",
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "m312.38 238.5c0-2.69-6.22-4.88-13.88-4.88s-13.87 2.19-13.87 4.88h2.43c0-1.35 5.12-2.44 11.44-2.44s11.44 1.09 11.44 2.44z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m312.38 238.5c0-2.69-6.22-4.88-13.88-4.88s-13.87 2.19-13.87 4.88h2.43c0-1.35 5.12-2.44 11.44-2.44s11.44 1.09 11.44 2.44z",
    fill: "none",
    stroke: "#a5a5a5",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8575)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(326.25,228)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8585)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m36.384 57.366c1.45 0 2.625 1.175 2.625 2.625s-1.175 2.625-2.625 2.625h-0.075c-1.427-0.026-2.566-1.198-2.55-2.625 2e-3 -1.449 1.176-2.623 2.625-2.625zm-0.819 3.42c0.202 0.208 0.479 0.327 0.769 0.33h0.05c0.621 0 1.125-0.504 1.125-1.125s-0.504-1.125-1.125-1.125-1.125 0.504-1.125 1.125v0.011c-7e-3 0.291 0.103 0.572 0.305 0.782z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.477 46.337-1.06 1.061-5.47-5.469-2.47 2.469-1.06-1.061 3.53-3.53z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.635 44.617h15.75v-1.5h-15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.477 37.336-1.06 1.06-5.47-5.47-2.47 2.47-1.06-1.06 3.53-3.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.635 35.616h15.75v-1.5h-15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.477 28.336-1.06 1.06-5.47-5.47-2.47 2.47-1.06-1.06 3.53-3.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.635 26.616h15.75v-1.5h-15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.477 19.336-1.06 1.06-5.47-5.47-2.47 2.47-1.06-1.06 3.53-3.531z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.635 17.616h15.75v-1.5h-15.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m58.884 58.132c0 1.657-1.343 3-3 3h-11.25v1.5c-2e-3 2.07-1.68 3.747-3.75 3.75h-9c-2.07-3e-3 -3.748-1.68-3.75-3.75v-1.5h-11.25c-1.657 0-3-1.343-3-3v-48.766c0-1.6568 1.343-3 3-3h39c1.657 0 3 1.3432 3 3zm-32.25 1.5h3v3c0 1.242 1.007 2.25 2.25 2.25h9c1.243 0 2.25-1.008 2.25-2.25v-3h3v-6.016h-19.5zm29.25-51.766h-39c-0.828 0-1.5 0.6715-1.5 1.5v48.766c0 0.828 0.672 1.5 1.5 1.5h8.25v-7.516h22.5v7.516h8.25c0.828 0 1.5-0.672 1.5-1.5v-48.766c0-0.8285-0.672-1.5-1.5-1.5z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8613)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(-.16649 -.54456 .55784 -.17055 178.91 275.74)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8623)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m67.329 61.398c0.787 0.89 0.98 2.686-1.075 4.822-0.872 0.979-2.098 1.572-3.408 1.646-0.581 0.028-1.15-0.171-1.588-0.554l-22.715-21.201-2.283-2.271-14.584-15.141c-0.567-0.581-1.114-1.181-1.641-1.8l-6.482-7.314-2.025-2.553-5.3848-7.0413c-0.2102-0.3768-0.1308-0.849 0.1913-1.1362l-1.7063-2.775c-0.1983-0.3129-0.1494-0.7221 0.117-0.9795 0.147-0.1485 0.3469-0.2327 0.5558-0.234 0.1506 7e-4 0.298 0.0438 0.4252 0.1245l2.748 1.725c0.1922-0.1906 0.4495-0.301 0.72-0.309 0.1435-0.0023 0.2844 0.0393 0.4035 0.1192l7.0973 5.3373 2.566 2.012 7.314 6.483c0.619 0.526 1.219 1.073 1.8 1.64l15.142 14.585 2.273 2.281 17.969 18.802 0.191 0.2 0.592-0.592c0.586-0.585 0.586-1.535 0-2.121l-13.38-13.38c-0.297-0.288-0.304-0.763-0.015-1.06 0.288-0.297 0.763-0.304 1.06-0.015 6e-3 6e-3 0.013 0.012 0.018 0.018l13.381 13.38c1.171 1.171 1.171 3.07 0 4.242l-0.616 0.616 0.838 0.876zm-57.926-53.141-1.5285 1.5293 4.827 6.313 0.437 0.551 3.178-3.177-0.525-0.41zm17.924 14.816c-0.554-0.541-1.134-1.07-1.748-1.592l-7.28-6.45-0.795-0.624-3.428 3.428 0.625 0.787 6.475 7.307c0.503 0.591 1.032 1.171 1.575 1.732l14.566 15.116 0.537 0.533 5.133-5.133-0.512-0.514zm17.4 16.85-0.681-0.684-5.129 5.129 0.667 0.663 22.696 21.185 0.014 0.013 0.019 0.018c0.162 0.09 0.347 0.132 0.532 0.119 0.897-0.087 1.728-0.511 2.325-1.187 1.238-1.286 1.41-2.332 1.045-2.775l-1.475-1.543-2.066-2.161z",
    fill: "#000000"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8633)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.5104,-1.88e-7,-3.77e-7,3.5104,373.5,128.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8643)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.134 28.116v18h-9v18h-19.5v-18h-9v-18h-9v-19.5h55.5v19.5zm-1.5 16.5v-16.5h-16.5v16.5zm-25.5 18h16.5v-16.5h-16.5zm-9-18h16.5v-16.5h-16.5zm7.5-34.5h-16.5v16.5h16.5zm18 0h-16.5v16.5h16.5zm18 0h-16.5v16.5h16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.384 57.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 39.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.384 21.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.384 21.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.384 21.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.384 39.366h3.75v3h-3.75z"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8665)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.4896,-1.88e-7,-7.54e-7,3.5104,570.75,127.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8675)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.134 28.116v18h-9v18h-19.5v-18h-9v-18h-9v-19.5h55.5v19.5zm-1.5 16.5v-16.5h-16.5v16.5zm-25.5 18h16.5v-16.5h-16.5zm-9-18h16.5v-16.5h-16.5zm7.5-34.5h-16.5v16.5h16.5zm18 0h-16.5v16.5h16.5zm18 0h-16.5v16.5h16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.384 57.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 39.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.384 21.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.384 21.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.384 21.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.384 39.366h3.75v3h-3.75z"
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "m279.38 259.5c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "#ffffff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m279.38 259.5c0 8.91 7.55 16.12 16.87 16.12s16.88-7.21 16.88-16.12-7.56-16.13-16.88-16.13-16.87 7.22-16.87 16.13z",
    fill: "none",
    stroke: "#ffffff",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "m301.01 261.95c0-0.79-0.63-1.42-1.41-1.42-0.79 0-1.42 0.63-1.42 1.42 0 0.78 0.63 1.41 1.42 1.41 0.78 0 1.41-0.63 1.41-1.41z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m282.56 255.82c0-0.78-0.63-1.41-1.42-1.41-0.78 0-1.41 0.63-1.41 1.41 0 0.79 0.63 1.42 1.41 1.42 0.79 0 1.42-0.63 1.42-1.42z",
    fill: "#000000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8705)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(3.6771,-1.88e-7,-7.54e-7,3.6875,695.25,125.25)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "scale(.98969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath8715)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m55.134 28.116v18h-9v18h-19.5v-18h-9v-18h-9v-19.5h55.5v19.5zm-1.5 16.5v-16.5h-16.5v16.5zm-25.5 18h16.5v-16.5h-16.5zm-9-18h16.5v-16.5h-16.5zm7.5-34.5h-16.5v16.5h16.5zm18 0h-16.5v16.5h16.5zm18 0h-16.5v16.5h16.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.384 57.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.384 39.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.384 21.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30.384 21.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.384 21.366h3.75v3h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39.384 39.366h3.75v3h-3.75z"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg12);
export default __webpack_public_path__ + "static/media/12.332ab44c988cac1e3bb0c8c80569fe0a.svg";
export { ForwardRef as ReactComponent };